<!--  -->
<template>
	<div class="Box">
		<el-dialog :title="title" :close-on-click-modal="false" :visible.sync="RechargeFlag" width="80%" :before-close="addClose">
			<el-card class="box-card">
				<h1 style="margin-bottom: 20px; margin-left: 120px">{{ paramsMovie.movie_Name }}</h1>
				<div class="Left">
					<el-form ref="form" :model="form" label-width="80px" :rules="ruless">
						<el-form-item label="模板说明" style="margin-left: 120px" prop="name">
							<el-input v-model="form.name" placeholder="请输入模板说明" style="width: 50%" clearable></el-input>
						</el-form-item>
						<el-form-item label="标签" style="margin-left: 120px">
							<el-select v-model="form.recharge_tag" placeholder="请选择标签">
								<!-- <el-option v-for="dict in recharge_tagList" :key="dict.id" :label="dict.name" :value="dict.id" /> -->
								<el-option label="默认" :value="0"></el-option>
								<el-option label="大额" :value="1"></el-option>
								<el-option label="小额" :value="2"></el-option>
							</el-select>
						</el-form-item>

						<el-form-item label="区分" :label-width="formLabelWidth" prop="status" style="margin-left: 100px">
							<el-radio-group v-model="form.is_open">
								<el-radio :label="0">不区分</el-radio>
								<el-radio :label="1">充值状态</el-radio>
								<!-- <el-radio :label="2">奇偶数</el-radio> -->
							</el-radio-group>
						</el-form-item>
						<div style="display: flex; justify-content: space-around">
							<el-form-item label="" :label-width="formLabelWidth" prop="status">
								<div style="display: flex">
									<el-card class="box-card">
										<div slot="header" class="clearfix">
											<span>充值档位</span>
											<el-button style="float: right; padding: 3px 0" type="text">{{ form.is_open == 2 ? '奇数' : '已充值' }}</el-button>
										</div>
										<div style="display: flex; justify-content: space-between; flex-wrap: wrap">
											<div class="btnAd" v-for="(item, index) in CZOne" :key="index">
												<div class="price">{{ item.money }}元</div>
												<div>
													<div v-if="item.recharge_type == 0" style="position: relative">
														<div class="bi">{{ (item.money * 100).toFixed(0) }}k币+{{ item.free_balance }}k币</div>
														<div class="dingBtn" v-if="item.goods_mark_txt">{{ item.goods_mark_txt }}</div>
													</div>
													<div class="bi" v-else>{{ item.description }}</div>
												</div>

												<div>
													<div class="song" v-if="item.recharge_type == 0">多送{{ item.free_balance / 100 }}元</div>
													<div class="song" v-else>免费{{ item.day }}天</div>
												</div>
												<div style="width: 100%; height: 10px; position: relative">
													<i style="position: absolute; bottom: -8px; right: 0" class="el-icon-edit" @click="Updateitem(item)"></i>
													<i style="position: absolute; bottom: -8px; right: 24px" @click="deleteItem(index)" class="el-icon-delete"></i>
												</div>
											</div>
											<div class="btnAds" @click="Dialog">
												<i class="el-icon-plus"></i>
											</div>
										</div>
										<div class="btn">立即充值</div>
									</el-card>
								</div>
							</el-form-item>
							<el-form-item label="" :label-width="formLabelWidth" prop="status">
								<el-card class="box-card" v-if="form.is_open != 0">
									<div slot="header" class="clearfix">
										<span>充值档位</span>
										<el-button style="float: right; padding: 3px 0" type="text">{{ form.is_open == 2 ? '偶数' : '未充值' }}</el-button>
									</div>
									<div style="display: flex; justify-content: space-between; flex-wrap: wrap">
										<div class="btnAd" v-for="(item, index) in CZTwo" :key="index">
											<div class="price">{{ item.money }}元</div>
											<div>
												<div v-if="item.recharge_type == 0" style="position: relative">
													<div class="bi">{{ (item.money * 100).toFixed(0) }}k币+{{ item.free_balance }}k币</div>
													<div class="dingBtn" v-if="item.goods_mark_txt">{{ item.goods_mark_txt }}</div>
												</div>
												<div class="bi" v-else>{{ item.description }}</div>
											</div>

											<div>
												<div class="song" v-if="item.recharge_type == 0">多送{{ item.free_balance / 100 }}元</div>
												<div class="song" v-else>免费{{ item.day }}天</div>
											</div>
											<div style="width: 100%; height: 10px; position: relative">
												<i style="position: absolute; bottom: -8px; right: 0" class="el-icon-edit" @click="Updateitem(item)"></i>
												<i style="position: absolute; bottom: -8px; right: 24px" @click="deleteItemTwo(index)" class="el-icon-delete"></i>
											</div>
										</div>
										<div class="btnAds" @click="DialogB">
											<i class="el-icon-plus"></i>
										</div>
									</div>
									<div class="btn">立即充值</div>
								</el-card>
							</el-form-item>
						</div>

						<el-form-item style="margin-left: 70px">
							<el-button type="primary" @click="onSubmit">保存</el-button>
							<el-button @click="None">重置</el-button>
						</el-form-item>
					</el-form>
				</div>
				<!-- 弹框 -->
				<el-dialog title="添加" :close-on-click-modal="false" :visible.sync="dialogVisible" width="50%" :before-close="handleClose" append-to-body>
					<div class="waiAdd">
						<el-form :model="Yiform" label-width="100px" class="demo-ruleForm" ref="ruleForm" :rules="rules">
							<el-form-item label="充值类型" :label-width="formLabelWidth" prop="recharge_type" label-width="120px">
								<el-select v-model="Yiform.recharge_type" placeholder="请选择活动区域" @change="handleSelectChange()">
									<el-option v-for="dict in recharge_typeList" :key="dict.id" :label="dict.name" :value="dict.id" />
								</el-select>
							</el-form-item>
							<el-form-item v-if="this.Yiform.recharge_type == 1" label="VIP充值金额" label-width="120px" prop="money">
								<el-select v-model="Yiform.money" filterable @change="handleOption(Yiform.money)">
									<el-option v-for="dict in YiformList" :key="dict.id" :label="dict.customField" :value="dict.id" />
								</el-select>
							</el-form-item>
							<el-form-item v-if="this.Yiform.recharge_type == 1" label="VIP天数" :label-width="formLabelWidth" prop="day">
								<el-input v-model="this.Addday.day" disabled></el-input>
							</el-form-item>
							<el-form-item v-if="this.Yiform.recharge_type == 1" label="VIP提示语" :label-width="formLabelWidth" prop="description">
								<el-input v-model="this.Addday.description"></el-input>
							</el-form-item>

							<el-form-item label="充值金额" v-if="this.Yiform.recharge_type == 0" :label-width="formLabelWidth" prop="money">
								<el-input v-model="Yiform.money"></el-input>
							</el-form-item>
							<el-form-item label="赠送K币" v-if="this.Yiform.recharge_type == 0" :label-width="formLabelWidth">
								<el-input v-model="Yiform.free_balance"></el-input>
							</el-form-item>
							<el-form-item label="角标内容" :label-width="formLabelWidth">
								<el-input v-model="Yiform.goods_mark_txt"></el-input>
							</el-form-item>
						</el-form>
					</div>
					<span slot="footer" class="dialog-footer">
						<el-button @click="dialogVisible = false">取 消</el-button>
						<el-button type="primary" @click="submitForm">确 定</el-button>
					</span>
				</el-dialog>
			</el-card>
		</el-dialog>
	</div>
</template>

<script>
import { RechargeAPI } from '@/api/popularize/Recharge';
import { processErrors } from "@/utils/errorHandler";
import { VipApi } from '@/api/vipRecharge/index';

export default {
	// props: ['RechargeFlag', 'paramsMovie', 'id'],
	props: ['RechargeFlag', 'paramsMovie', 'id'],
	components: {},
	data() {
		return {
			title: '充值模板',
			formLabelWidth: '',
			states: true,
			show: 0,
			form: {
				recharge_tag: 0,
				is_open: 1,
				// movie_id: '',
				name: '',
				platform_type: 1,
				id: '',
				w_recharge_gear: [], //未充值
				recharge_gear: [], //已充值
			},
			Addday: {},
			CZOne: [],
			CZTwo: [],
			dialogVisible: false,
			Yiform: {
				recharge_type: 0, //是否是vip
				money: '', //充值金额
				free_balance: '', //赠送书币
				goods_mark_txt: '', //提示语
				balance_all: '',
			},
			ruless: {
				name: [{ required: true, message: '请输入昵称', trigger: 'blur' }],
			},
			YiformListAll: [],
			YiformList: [],
			recharge_typeList: [
				{ id: 0, name: '普通充值' },
				{ id: 1, name: 'VIP充值' },
			],
			recharge_tagList: [
				{ id: 0, name: '默认' },
				{ id: 1, name: '大额' },
				{ id: 2, name: '小额' },
			],
			rules: {
				recharge_type: [{ required: true, message: '请输入充值类型', trigger: 'blur' }],
				money: [{ required: true, message: '请输入充值金额', trigger: 'blur' }],
				balance: [{ required: true, message: '请输入充值金额', trigger: 'blur' }],
				// day:[
				//     { required: true, message: "请输入充值天数", trigger: "blur" }
				// ],
				// description:[
				//     { required: true, message: "请输入提示语", trigger: "blur" }
				// ],
			},
			Select: [],
			mobanId: '',
		};
	},
	methods: {
		getSelect() {
			let api = RechargeAPI();
			api.Rechargetmpla(this.paramsMovie.movie_id).then((res) => {
				this.Select = res.data;
			});
		},
		addClose() {
			this.$emit('RechargeNone');
		},
		Dialog() {
			this.dialogVisible = true;
			this.Yiform = {
				recharge_type: 0, //是否是vip
				money: '', //充值金额
				free_balance: '', //赠送书币
				goods_mark_txt: '', //提示语
			};
			this.states = true;
		},

		DialogB() {
			this.dialogVisible = true;
			this.Yiform = {
				recharge_type: 0, //是否是vip
				money: '', //充值金额
				free_balance: '', //赠送书币
				goods_mark_txt: '', //提示语
			};
			this.states = false;
		},
		deleteItem(index) {
			this.CZOne.splice(index, 1);
		},
		deleteItemTwo(index) {
			this.CZTwo.splice(index, 1);
		},
		Updateitem(item) {
			this.show = 1;
			this.dialogVisible = true;
			this.Yiform = item;
			if (item.recharge_type == 1) {
				this.Addday = {
					money: item.money,
					day: item.day,
					description: item.description,
				};
        let params = {
          sort: 'money',
          sortType: 'asc',
        };
				const api = VipApi();
				api
					.getvipList(params)
					.then((res) => {
						if (res.code == 0) {
							// this.YiformList = res.data.data
							this.YiformList = res.data.data.map((item) => ({
								...item, // 保留原始对象的所有属性
								customField: `${item.money}元 = ${item.day}天会员`, // 添加新的 customField 字段
							}));
							this.YiformListAll = res.data.data;
						}else{
              processErrors(res);
            }
					})
					.catch((error) => {
						console.error('Error fetching user data:', error);
						this.loading = false;
					});
			}
		},
		submitForm() {
			// this.show=0

			if (this.states == true) {
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						if (this.Yiform.recharge_type == 0) {
							if (this.show == 0) {
								let money = parseFloat(this.Yiform.money);
								let freeBalance = parseFloat(this.Yiform.free_balance);
								let objar = {
									...this.Yiform,
									balance_all: (money * 100 + freeBalance).toFixed(0), // 保持浮点数运算并格式化为字符串
									balance: (money * 100).toFixed(0), // 保持浮点数运算并格式化为字符串
								};
								this.CZOne.push(objar);
								this.Yiform = {
									recharge_type: 0, //是否是vip
									money: 0, //充值金额
									free_balance: '', //赠送书币
									goods_mark_txt: '', //提示语
								};
								this.dialogVisible = false;
								this.show = 0;
							} else {
								this.dialogVisible = false;
								this.show = 0;
							}
						} else {
							if (this.show == 0) {
								let ar = {
									...this.Yiform,
									money: this.Addday.money,
									day: this.Addday.day,
									description: this.Addday.description,
								};
								this.CZOne.push(ar);
								(this.Yiform = {
									recharge_type: 0, //是否是vip
									money: '', //充值金额
									free_balance: '', //赠送书币
									goods_mark_txt: '', //提示语
								}),
									(this.dialogVisible = false);
								this.show = 0;
							} else {
								// 	this.Yiform = {
								// 	recharge_type: 1, //是否是vip
								// 	money: '', //充值金额
								// 	free_balance: '', //赠送书币
								// 	goods_mark_txt: '', //提示语
								// },
								this.dialogVisible = false;
								this.show = 0;
							}
						}
					}
				});
			} else {
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						if (this.Yiform.recharge_type == 0) {
							if (this.show == 0) {
								let money = parseFloat(this.Yiform.money);
								let freeBalance = parseFloat(this.Yiform.free_balance);
								let objar = {
									...this.Yiform,
									balance_all: (money * 100 + freeBalance).toFixed(0), // 保持浮点数运算并格式化为字符串
									balance: (money * 100).toFixed(0), // 保持浮点数运算并格式化为字符串
								};
								this.CZTwo.push(objar);
								this.Yiform = {
									recharge_type: 0, //是否是vip
									money: 0, //充值金额
									free_balance: '', //赠送书币
									goods_mark_txt: '', //提示语
								};
								this.dialogVisible = false;
								this.show = 0;
							} else {
								// 	this.Yiform = {
								// 	recharge_type: 0, //是否是vip
								// 	money: 0, //充值金额
								// 	free_balance: '', //赠送书币
								// 	goods_mark_txt: '', //提示语
								// };
								this.dialogVisible = false;
								this.show = 0;
							}
						} else {
							if (this.show == 0) {
								let ar = {
									...this.Yiform,
									day: this.Addday.day,
									description: this.Addday.description,
									money: this.Addday.money,
								};
								this.CZTwo.push(ar);

								this.dialogVisible = false;
								this.show = 0;
							} else {
								this.dialogVisible = false;
								this.show = 0;
							}
						}
					}
				});
			}
		},

		onSubmit() {
			const formData = {
				...this.form,

				recharge_gear: JSON.stringify(this.CZOne), // 将VIP天数添加到表单数据中
				w_recharge_gear: JSON.stringify(this.CZTwo), // 将VIP天数添加到表单数据中
				// 其他表单项根据需要添加
			};
			if (formData.is_open == 0) {
				const { w_recharge_gear, ...formDataWithoutW } = this.form;
				const formDataY = {
					...formDataWithoutW,
					movie_id: this.mobanId,
					recharge_gear: JSON.stringify(this.CZOne), // 将VIP天数添加到表单数据中
					// 其他表单项根据需要添加
				};
				if (this.CZOne.length < 1) {
					this.$message.error('至少添加1个额度');
				} else {
					const api = RechargeAPI();
					api.AddRecharge(formDataY).then((res) => {
						if (res.code == 0) {
							this.$message.success('保存成功');
							this.Getinfos();
							this.$emit('RechargeNone');
						} else {
							this.$message.error(res.msg);
						}
					});
				}
			} else {
				if (this.CZOne.length < 1 || this.CZTwo.length < 1) {
					this.$message.error('至少添加1个额度');
				} else {
					const api = RechargeAPI();
					api.AddRecharge(formData).then((res) => {
						if (res.code == 0) {
							this.$message.success('保存成功');
							this.$emit('RechargeNone');
						} else {
							this.$message.error(res.msg);
						}
					});
				}
			}
		},
		handleOption(e) {
			// if (this.YiformListAll) {
			this.Addday = this.YiformListAll.find((item) => item.id === e);
			// }
		},
		None() {
			this.form = {
				recharge_tag: 0,
				is_open: 1,
				platform_type: 1,
				w_recharge_gear: [], //未充值
				recharge_gear: [], //已充值
			};
		},
		handleSelectChange() {
			if (this.Yiform.recharge_type == 1) {
				(this.Yiform.money = ''), (this.Yiform.goods_mark_txt = '');
				this.Yiform.free_balance = '';
        let params = {
          sort: 'money',
          sortType: 'asc',
        };
				const api = RechargeAPI();
				api
					.getvipList(params)
					.then((res) => {
						if (res.code == 0) {
							// this.YiformList = res.data.data
							this.YiformList = res.data.data.map((item) => ({
								...item, // 保留原始对象的所有属性
								customField: `${item.money}元 = ${item.day}天会员`, // 添加新的 customField 字段
							}));
							this.YiformListAll = res.data.data;
						}
					})
					.catch((error) => {
						this.loading = false;
					});
			} else {
				this.Yiform = {
					recharge_type: 0, //是否是vip
					money: 0, //充值金额
					free_balance: '', //赠送书币
					goods_mark_txt: '', //提示语
				};
			}
		},
		handleClose(done) {
			done();
			this.$refs['ruleForm'].resetFields();
			this.Yiform = {
				recharge_type: 0, //是否是vip
				balance: 0, //充值金额
				free_balance: '', //赠送书币
				goods_mark_txt: '', //提示语
			};
		},
		//详情接口
		Getinfos() {
			const api = RechargeAPI();
			if (this.id != '') {
				api.goods_rechargeinfo(this.id).then((response) => {
					this.form.id = this.id;
					this.form = response.data;
					this.form.is_open = response.data.is_open;
					this.form.recharge_tag = response.data.recharge_tag;
					this.CZOne = response.data.recharge_gear;
					this.CZTwo = response.data.w_recharge_gear;
				});
			}
		},
	},
	created() {},
	mounted() {
		this.Getinfos();
		// this.title =
		// 	'预览 -' +
		// 	'ID：' +
		// 	this.videoObj.id +
		// 	'- 剧名：' +
		// 	this.videoObj.name +
		// 	'- 原剧名：' +
		// 	this.videoObj.origin_name +
		// 	'- CP名：' +
		// 	this.videoObj.cp_name;
		// let api = WorksListAPI();
		// api.VideoList(this.videoObj.id).then((res) => {
		// 	if (res.code == 0) {
		// 		this.videoUrl = res.data[0].resource;
		// 		this.videoList = res.data;
		// 	}
		// });
		this.getSelect();
		// this.form.movie_id = this.paramsMovie.movie_id;
		this.mobanId = this.$route.query.key;
	},
};
</script>
<style lang="scss" scoped>
.Box {
	.Left {
		width: 60%;
		height: 100%;

		.text {
			font-size: 14px;
		}

		.item {
			margin-bottom: 18px;
		}

		.clearfix:before,
		.clearfix:after {
			display: table;
			content: '';
		}

		.clearfix:after {
			clear: both;
		}

		.box-card {
			width: 380px;
			margin-left: 50px;

			.btn {
				width: 100%;
				height: 30px;
				background-color: #1890ff;
				color: #fff;
				border-radius: 32px;
				margin-top: 10px;
				line-height: 30px;
				text-align: center;
			}

			.btnAd {
				width: 150px;
				height: 110px;
				border: #ccc 1px solid;
				border-radius: 10px;
				margin-top: 10px;
				padding: 10px;

				.price {
					font-size: 15px;
					line-height: 10px;
				}

				.bi {
					font-size: 10px;
					// margin-top: 6px;
				}
				.dingBtn {
					position: absolute;
					top: -10px;
					right: -10px;
					height: 20px;
					background-color: antiquewhite;
					line-height: 18px;
					text-align: center;
					padding: 2px 6px;
					background-color: #1890ff;
					color: #fff;
					border-top-left-radius: 10px;
					border-bottom-left-radius: 10px;
					font-size: 11px;
				}
				.song {
					width: 100%;
					line-height: 20px;
					text-align: center;
					font-size: 13px;
					margin-top: 10px;
					background-color: #1890ff;
					border-radius: 10px;
					color: #fff;
				}
			}

			.btnAds {
				width: 150px;
				height: 110px;
				border: #ccc 1px solid;
				border-radius: 10px;
				margin-top: 10px;
				text-align: center;
				line-height: 110px;

				i {
					font-size: 23px;
				}
			}
		}
	}

	.waiAdd {
		width: 80%;
		height: 100%;
		margin: auto;
	}
}

.el-card__body {
	padding: 0px !important;
}

.btn_left {
	margin-left: 100px;
}

.div_buttom {
	width: 100%;
	height: 30px;
	// display: flex;
	margin-bottom: 20px;
}
</style>
